import { makeStyles } from '@/styles/theme/tss-react';

interface Props {
  isOnDark: boolean;
}

const useStyles = makeStyles<Props>({
  name: 'FeatureLink',
})(({ brandColors, type, breakpoints, typography }, { isOnDark }) => {
  // Card-level hover affordance so hovering anywhere on the card (e.g. the
  // image) previews the same hover state as hovering the button directly.
  // Each variant reuses its own real hover treatment from
  // BaseLibrary/Button/Button.styles.ts exactly: Primary only shifts its
  // background (it has no border, and its text color doesn't change on
  // hover there either); Secondary/Tertiary share the same background/color
  // shift and never gain a border, since the button's border color is
  // static (set once via `classes.border` in Button.tsx) and unaffected by
  // hover.
  const primaryCardHoverStyle = {
    '&:hover': {
      '& button': {
        backgroundColor: `${
          isOnDark ? brandColors.tintsHeroBlue80 : brandColors.mediumBlue
        }`,
      },
    },
  };

  const secondaryOrTertiaryCardHoverStyle = {
    '&:hover': {
      '& button': {
        color: `${isOnDark ? 'white' : brandColors.mediumBlue}`,
        backgroundColor: `${
          isOnDark
            ? brandColors.foregroundInverseSubtle
            : brandColors.interactiveHeroBlueSubtle
        }`,
      },
    },
  };

  return {
    card: {
      justifyContent: 'space-between',
      borderRadius: typography.pxToRem(24),
      display: 'flex',
      flexDirection: 'column',
      ...type['20_regular'],
      width: 'auto',
      height: '100%',
      background: `${
        isOnDark
          ? 'linear-gradient(180deg, #000 5.73%, rgba(0, 0, 0, 0.00) 72.92%), rgba(0, 0, 0, 0.80)'
          : brandColors.tintsHeroBlue80
      }`,
      [breakpoints.up('md')]: { ...type['28_medium'] },
      [breakpoints.up('lg')]: {
        width: '100%',
        height: typography.pxToRem(370),
      },
    },
    Primary: primaryCardHoverStyle,
    Secondary: secondaryOrTertiaryCardHoverStyle,
    Tertiary: secondaryOrTertiaryCardHoverStyle,
    cardBackgroundImg: {
      width: '100%',
      height: '100%',
      borderRadius: typography.pxToRem(24),
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      [breakpoints.up('lg')]: {
        backgroundSize: '100%',
        transition: 'background-size .5s',
        '&:hover': {
          backgroundSize: '110%',
        },
      },
    },
    linkContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      padding: typography.pxToRem(32),
      // Anchor reset styles for visual parity
      textDecoration: 'none',
      color: 'inherit',
      '&:hover': {
        textDecoration: 'none',
      },
      '&:focus': {
        textDecoration: 'none',
      },
      '&:visited': {
        color: 'inherit',
      },
    },
    title: {
      color: `${isOnDark ? brandColors.white : brandColors.mediumBlue}`,
      width: '80%',
      [breakpoints.up('sm')]: {
        width: '40%',
      },
      [breakpoints.up('md')]: {
        width: '50%',
      },
    },
  };
});

export default useStyles;
